<template>
  <div class="infoArea" v-if="!typeWarning">
    <base-icon name="info" class="icon"></base-icon>
    <p class="text">{{ infoText }}</p>
  </div>
  <div class="infoArea yellow" v-else>
    <base-icon name="warn-yellow" class="icon"></base-icon>
    <p class="text">{{ infoText }}</p>
  </div>
</template>

<script>
import { BaseIcon } from "@/components";

export default {
  name: "InfoArea",
  components: {
    BaseIcon,
  },
  props: {
    infoText: String,
    typeWarning: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.infoArea {
  position: absolute;
  bottom: 0;
  flex-direction: row;
  text-align: center;
  color: #92929b;
  display: flex;
  font-size: 12px;
  padding: 20px;
  left: 0;
  right: 0;
  border-radius: var(--radius-second);
  justify-content: center;
  align-items: center;

  .icon {
    margin-right: 6px;
  }
  svg {
    flex-shrink: 0;
    margin-right: 10px;
  }

  &.yellow {
    color: var(--color-primary-warning-text) !important;
    background: var(--color-primary-warning-text-background) !important;
    font-size: 13px;
    justify-content: flex-start;
    @media (max-width: 768px) {
      align-items: flex-start;
    }
  }

  @media (max-width: 768px) {
    text-align: left;
  }
}
</style>
